import React from "react";
import clsx from "clsx";

/**
 * AdminCard
 * A simple glassy card used across the admin area for visual consistency.
 */
const AdminCard = ({ className = "", children, ...rest }) => (
  <div
    className={clsx(
      "bg-white/5 border border-white/10 rounded-xl backdrop-blur-sm",
      className
    )}
    {...rest}
  >
    {children}
  </div>
);

export default AdminCard;